import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { IncidentModal } from './IncidentModal';
import { AppData } from '../../types';
import { formatDateTime } from '../../utils/dateFormat';
import { Plus, MapPin, Calendar, Tag } from 'lucide-react';
interface IncidentsTabProps {
  data: AppData;
  onAddIncident: (incident: any) => void;
}
export function IncidentsTab({
  data,
  onAddIncident
}: IncidentsTabProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filter, setFilter] = useState('All');
  const filteredIncidents = filter === 'All' ? data.incidents : data.incidents.filter(i => i.category === filter);
  const sortedIncidents = [...filteredIncidents].sort((a, b) => new Date(b.datetime).getTime() - new Date(a.datetime).getTime());
  return <div className="space-y-6 max-w-5xl mx-auto" data-id="element-188">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-189">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-190">Incidents</h2>
        <div className="flex gap-3 w-full sm:w-auto" data-id="element-191">
          <select className="px-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-purple bg-white" value={filter} onChange={e => setFilter(e.target.value)} data-id="element-192">
            <option value="All" data-id="element-193">All Categories</option>
            <option value="Harassment" data-id="element-194">Harassment</option>
            <option value="Discrimination" data-id="element-195">Discrimination</option>
            <option value="Injury" data-id="element-196">Injury</option>
            <option value="Unsafe Conditions" data-id="element-197">Unsafe Conditions</option>
            <option value="Other" data-id="element-198">Other</option>
          </select>
          <Button onClick={() => setIsModalOpen(true)} leftIcon={<Plus className="w-4 h-4" data-id="element-200" />} data-id="element-199">
            New Incident
          </Button>
        </div>
      </div>

      {sortedIncidents.length === 0 ? <div className="text-center py-12 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200" data-id="element-201">
          <p className="text-gray-500 mb-4" data-id="element-202">No incidents documented yet</p>
          <Button variant="secondary" onClick={() => setIsModalOpen(true)} data-id="element-203">
            Document Your First Incident
          </Button>
        </div> : <div className="grid gap-4" data-id="element-204">
          {sortedIncidents.map(incident => <Card key={incident.id} hover className="flex flex-col md:flex-row gap-6" data-id="element-205">
              <div className="flex-1" data-id="element-206">
                <div className="flex items-start justify-between mb-2" data-id="element-207">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-208">
                    {incident.title}
                  </h3>
                  <Badge variant={incident.category === 'Harassment' ? 'red' : incident.category === 'Injury' ? 'yellow' : 'blue'} data-id="element-209">
                    {incident.category}
                  </Badge>
                </div>

                <div className="flex flex-wrap gap-4 text-sm text-gray-500 mb-4" data-id="element-210">
                  <div className="flex items-center gap-1" data-id="element-211">
                    <Calendar className="w-4 h-4" data-id="element-212" />
                    {formatDateTime(incident.datetime)}
                  </div>
                  {incident.location && <div className="flex items-center gap-1" data-id="element-213">
                      <MapPin className="w-4 h-4" data-id="element-214" />
                      {incident.location}
                    </div>}
                </div>

                <p className="text-gray-700 line-clamp-2 mb-3" data-id="element-215">
                  {incident.description}
                </p>

                {incident.peopleIds.length > 0 && <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-216">
                    <UsersIcon className="w-4 h-4" data-id="element-217" />
                    <span data-id="element-218">{incident.peopleIds.length} people involved</span>
                  </div>}
              </div>
            </Card>)}
        </div>}

      <IncidentModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={onAddIncident} people={data.people} data-id="element-219" />
    </div>;
}
function UsersIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-220">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" data-id="element-221" />
    </svg>;
}